module.exports = __webpack_public_path__ + "static/staticSectionImage4-fcb9c37a7b9ffe87b18a750dada3277d.png";